export default {
    "recent_activity":"Recent Activity",
    "you_have_unfinished_invoice":"You have unfinished Invoice",
    "you_have_unfinished_estimate":"You have unfinished Estimate",
    "invoice":"Invoice",
    "estimate":"Estimate",
    "home":"Home",
    "document":"Document",
    "client":"Client",
    "report":"Report",
    "new":"New",
    "no_client_found":"No client found.",
    "search":"Search",
    "clients":"Clients",
    "documents":"Documents",
    "no_document_found":"No document found.",
    "cancel":"Cancel",
    "new_client":"New Client",
    "add_client":"Add Client",
    "client_name_is_required":"Client name is required!",
    "client_name":"Client Name",
    "email":"Email",
    "phone":"Phone",
    "mobile":"Mobile",
    "fax":"Fax",
    "address":"Address",
    "address_1":"Address 1",
    "address_2":"Address 2",
    "city":"City",
    "state_province":"State/Province",
    "zip_postal_code":"Zip/Postal Code",
    "country":"Country",
    "filter_documents":"Filter Documents",
    "apply_filter":"Apply filter",
    "document_type":"Document Type",
    "all":"All",
    "send_state":"Send State",
    "sent":"Sent",
    "not_sent":"Not Sent",
    "payment_state":"Payment State",
    "paid":"Paid",
    "not_paid":"Not Paid",
    "overdue":"Overdue",
    "date":"Date",
    "this_month":"This Month",
    "this_year":"This Year",
    "custom":"Custom",
    "from":"From",
    "to":"To",
    "preview":"Preview",
    "summary":"Summary",
    "estimate_number":"Estimate Number",
    "issued":"Issued",
    "valid_until":"Valid Until",
    "history":"History",
    "show":"Show",
    "share":"Share",
    "print":"Print",
    "download_pdf":"Download pdf",
    "send_estimate":"Send Estimate",
    "document_history":"Document History",
    "mark_as_paid":"Mark as Paid",
    "paid":"Paid",
    "invoice_number":"Invoice Number",
    "due":"Due",
    "send_invoice":"Send Invoice",
    "new_item":"New Item",
    "name":"Name",
    "price":"Price",
    "item_name":"item name",
    "item_price":"item price",
    "item_name_is_required":"Item name is required!",
    "item_price_is_required":"Item price is required!",
    "item_tax_state":"Item tax state",
    "add_item":"Add Item",
    "new_service":"New Service",
    "unit":"Unit (Hour, Day)",
    "service_name_is_required":"Service name is required!",
    "service_price_is_required":"Service price is required!",
    "tax":"Tax",
    "service_tax_state":"Service tax state",
    "add_service":"Add Service",
    "items_and_services":"Items & Services",
    "items":"Items",
    "item":"Item",
    "services":"Services",
    "update_item":"Update Item",
    "are_you_sure":"Are you sure?",
    "this_action_will_delete_the_item":"This action will delete the item.",
    "delete":"Delete",
    "update":"Update",
    "update_service":"Update Service",
    "this_action_will_delete_the_service":"This action will delete the service.",
    "business":"Business",
    "business_details":"Business Details",
    "business_details_1":"Business details",
    "business_logo":"Business Logo",
    "business_name":"Business Name",
    "business_name_is_required":"Business name is required!",
    "mobile_number":"Mobile Number",
    "mobile_number_2":"Mobile Number 2",
    "website":"Website",
    "street":"Street",
    "street_2":"Street 2",
    "save":"Save",
    "settings":"Settings",
    "business_settings":"Business Settings",
    "payment_options":"Payment options",
    "tax_settings":"Tax settings",
    "document_settings":"Document Settings",
    "template_design_and_settings":"Template design & settings",
    "app_settings":"App Settings",
    "language":"Language",
    "theme":"Theme",
    "dark":"Dark",
    "light":"Light",
    "auto":"Auto",
    "subscription":"Subscription",
    "rate_us":"Rate us",
    "paypal_email_is_required":"Paypal Email is required",
    "online_payments":"Online Payments",
    "paypal":"Paypal",
    "paypal_email":"Paypal Email",
    "stripe":"Stripe",
    "payment_instructions":"Payment Instructions",
    "add_instructions":"Add instructions to get paid:\n- bank account information.\n- venmo, zelle, cash app.\n- other information.",
    "apply_tax_to_documents":"Apply TAX to Documents",
    "tax_label":"Tax label",
    "option_1":"Option 1 (%)",
    "option_2":"Option 2 (%)",
    "option_3":"Option 3 (%)",
    "itemsandservices":"Items&Services",
    "preview_and_customize":"Preview & Customize",
    "new_estimate":"New Estimate",
    "add_itemandservice":"Add Item/Service",
    "sub-total":"Sub-Total",
    "discount":"Discount",
    "total":"Total",
    "estimate_notes":"Estimate Notes",
    "create_estimate":"Create Estimate",
    "new_invoice":"New Invoice",
    "invoice_notes":"Invoice Notes",
    "create_invoice":"Create Invoice",
    "client_details":"Client Details",
    "save_changes":"Save Changes",
    "remove_this_client_from_the_document":"Remove this client from the document!",
    "contact":"Contact",
    "update_invoice":"Update Invoice",
    "item_details":"Item Details",
    "remove_this_item_from_the_document":"Remove this item from the document!",
    "quantity":"quantity",
    "item_quantity_is_required!":"Item quantity is required!",
    "total_price":"total price",
    "service_details":"Service Details",
    "remove_this_service_from_the_document":"Remove this service from the document!",
    "unit_type":"unit type",
    "service_quantity_is_required":"Service quantity is required!",
    "select_terms":"Select terms",
    "taxable":"Taxable",
    "non_taxable":"Non-Taxable",
    "total_estimates":"Total Estimates",
    "total_invoices":"Total Invoices",
    "service_name":"service name",
    "service_price":"service price",
    "no_item_found":"No item found.",
    "no_service_found":"No service found.",
    "select_your_language":"Select your language",
    "stripe_invoice_link":"Stripe invoice link",
    "update_estimate":"Update Estimate",
    "sub_total":"Sub-Total",
    "select_a_currency":"Select A Currency",
    "reports":"Reports",
    "customize":"Customize",
    "edit":"Edit",
    "invoices":"Invoices",
    "estimates":"Estimates",
    "get_statement":"Get Statement",
    "no_client_found_with_the_given_id":"No client found with the given ID.",
    "no_statement_found":"No Statement Found",
    "no_document_found_for_this_client":"No document found for this client.",
    "client_statment":"Client Statement",
    "send_statment":"Send Statement",
    "update_client":"Update Client",
    "remove_this_item":"Remove This Item",
    "remove_this_service":"Remove This Service",
    "set_as_default":"Set as Default",
    "top_invoiced_clients":"TOP INVOICED CLIENTS",
    "amount":"Amount",
    "invoices_up":"INVOICES",
    "quarter":"Quarter",
    "unpaid":"unPaid",
    "top_invoiced_items":"TOP INVOICED ITEMS",
    "quantity_up":"Quantity",
    "top_invoiced_services":"TOP INVOICED SERVICES",
    "last_year":"Last Year",
    "life_time":"Life Time",
    "ok":"OK",
    "invoice_send_template_subject":"Invoice #{document_number} from {business_name}",
    "invoice_send_template_email":"Hello {client_name},\n \nI hope this message finds you well.\n \nWe’ve issued a new invoice (#{document_number}) from {business_name}.\n \nYou can securely view or download it using the link below:\n \n🔗 https://snapbill.app/document/{document_id}\n \nIf you have any questions about this invoice or need assistance, please don’t hesitate to reach out to us at {business_email}.\n \nThank you for your trust in {business_name}.\n \nWe truly appreciate your business!\n \nWarm regards,\n \n{business_name} Team",
    "estimate_send_template_subject":"Estimate #{document_number} from {business_name}",
    "estimate_send_template_email":"Hello {client_name},\n \nI hope this message finds you well.\n \nWe’ve prepared an estimate (#{document_number}) from {business_name} for your review.\n \nYou can securely view or download it using the link below:\n \n🔗 https://snapbill.app/document/{document_id}\n \nIf you have any questions, adjustments, or would like to move forward, feel free to reply to this email or contact us at {business_email}.\n \nThank you for considering {business_name}.\n \nWe look forward to working with you!\n \nWarm regards,\n \n{business_name} Team",
    "statement_send_template_subject":"Statement from {business_name}",
    "statement_send_template_email":"Hello {client_name},\n \nI hope this message finds you well.\n \nYour latest statement from {business_name} is now available.\nThis statement provides a summary of your invoices and estimates for your review.\n \nYou can securely view or download it using the link below:\n \n🔗 https://snapbill.app/statement/{statment_number}\n \nIf you have any questions regarding this statement or need further details, please don’t hesitate to contact us at {business_email}.\n \nThank you for your continued trust in {business_name}.\n \nWarm regards,\n{business_name} Team",
    "no_internet_connection":"No Internet Connection",
    "you_need_an_internet_connection_to_send_or_share_your_invoice":"You need an internet connection to send or share your invoice.\nPlease check your connection and try again later, or choose one of the offline options (Print or Download as PDF) to continue.",
    "you_need_an_internet_connection_to_send_or_share_your_estimate":"You need an internet connection to send or share your estimate.\nPlease check your connection and try again later, or choose one of the offline options (Print or Download as PDF) to continue.",
    "you_need_an_internet_connection_to_send_or_share_your_statment":"You need an internet connection to send or share your Statement.\nPlease check your connection and try again later, or choose one of the offline options (Print or Download as PDF) to continue.",
    "error":"Error",
    "mail_composer_is_not_available_on_this_device":"Mail composer is not available on this device",
    "estimate_full_capital":"ESTIMATE",
    "invoice_full_capital":"INVOICE",
    "estimate_to":"ESTIMATE TO",
    "invoice_to":"INVOICE TO",
    "invoice_no":"Invoice No:",
    "issue_date":"Issue Date:",
    "due_date":"Due Date:",
    "valid_until":"Valid until:",
    "description":"Description",
    "unit_price":"Unit Price",
    "note":"Note:",
    "number_1":"Number 1",
    "number_2":"Number 2",
    "bill_to":"Bill to",
    "from_full_capital":"FROM",
    "details_full_capital":"DETAILS",
    "valid":"Valid",
    "select_contact":"Select Contact",
    "no_contacts":"No contacts found",
    "import_from_contacts":"Import from Contacts",
    "call":"Call",
    "message":"Message",
    "success":"Success",
    "pdf_saved":"PDF saved! Check Files app → On My iPhone → SnapBill",
    "not_send":"Not Send",
    "created":"Created",
    "send_to":"Send to",
    "signatures":"Signatures",
    "signature":"Signature",
    "new_signature":"New Signature",
    "signature_name_is_required":"Signature name is required",
    "clear":"Clear",
    "delete_signature":"Delete Signature",
    "this_action_will_delete_the_signature":"This action will delete the signature.",
    "no_signatures_found":"No signatures found",
    "add_your_signature":"Add Your Signature",
    "this_action_will_remove_the_signature_from_this_document":"This action will remove the signature from this document.",
    "on_receipt":"On Receipt",
    "three_days":"3 days",
    "ten_days":"10 days",
    "thirty_days":"30 days",
    "no_duo_date":"No Duo Date",
    "no_valid_date":"No Valid Date",
    "select_date":"Select date",
    "percentage":"Percentage",
    "fix":"Fix",
    "please_add_client_detail_to_the_invoice":"Please add client detail to the invoice",
    "please_add_at_least_one_item_to_the_invoice":"Please add at least one item to the invoice",
    "please_add_client_detail_to_the_estimate":"Please add client detail to the estimate",
    "please_add_at_least_one_item_to_the_estimate":"Please add at least one item to the estimate",
    "next":"Next",
    "get_started":"Get Started",
    "create_invoices_and_estimates_in_seconds":"Create Invoices & Estimates In Seconds",
    "auto_fill_client_details":"Auto-fill client details, apply templates, and send in less than 20 seconds.",
    "get_paid_faster_and_know_it_instantly":"Get Paid Faster & Know It Instantly",
    "snapbill_notifies_you_the_moment":"SnapBill notifies you the moment clients open your invoice, starting payment. No more guessing, just real-time updates and faster cash flow.",
    "see_your_business_in_full_color":"See Your Business in Full Color",
    "visualize_income_trends":"Visualize income trends, track overdue invoices, and spot your top clients, all through smart, clear reports that help you grow with confidence.",
    "unlimited_access":"Unlimited Access",
    "not_sure_yet":"Not sure yet?",
    "enable_free_access":"Enable Free Access",
    "best_offer":"Best Offer",
    "yearly_plan":"Yearly Plan",
    "per_week":"per Week",
    "three_days_free_trail":"3 Days Free Trail",
    "weekly_plan":"Weekly Plan",
    "countinue_with_three_days_free":"Countinue with 3 days free",
    "countinue_with_best_offer":"Countinue with best offer",
    "privacy":"Privacy",
    "already_subscribed":"Already Subscribed?",
    "terms":"Terms",
    "please_select_different_plan":"Please select different plan",
    "your_current_plan":"Your'e Current Plan",
    "statment_of_account":"Statment of Account",
    "statment_date":"Statment Date",
    "classic":"Classic",
    "modern":"Modern",
    "wave":"Wave",
    "estimate_no":"Estimate No:",
    "pay_now":"Pay now",
    "copy":"Copy",
    "copied":"Copied",
    "invalid_stripe_invoice_link":"Invalid Stripe invoice link",
    "client_name_viewed_your_invoice_document_number":"{client_name} viewed your Invoice #{document_number}",
    "client_name_viewed_your_estimate_document_number":"{client_name} viewed your Estimate #{document_number}",
    "client_name_started_paying_invoice":"{client_name} started paying Invoice #{document_number} via {payment_method}",
    "good_news":"Good news!"
}